<script setup lang="ts">
import { ref, watch } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import MogelijkLogo from '../../public/mogelijk-blauw.svg?url_encode';

export interface Props {
  alt: string;
  source?: string | null;
  theme?: 'lightbox' | null;
  imageClasses?: string;
  title?: string;
}

const props = withDefaults(defineProps<Props>(), {
  source: null,
  theme: null,
  imageClasses: '',
  title: '',
});

const fallBack = ref(false);

watch(
  () => props.source,
  value => {
    if(typeof value === 'string') {
      fallBack.value = false;
    }
  },
);
</script>

<template>
  <div
    :class="{
      'flex size-full items-center justify-center': !source,
      'rounded-t-3xl': !theme && !source,
    }"
    data-test-id="image-wrapper"
  >
    <div
      v-if="fallBack"
      class="flex size-full items-center justify-center"
      :class="{'bg-blue-200': !theme}"
      data-test-id="fallback-wrapper"
    >
      <FontAwesomeIcon
        :icon="['fad', 'image-slash']" 
        :size="theme ? '4x' : '2x'"
        :title="props.title && props.title.length > 0 ? props.title : props.alt"
        data-test-id="fallback-icon"
      />
      <span class="sr-only">Image not found</span>
    </div>
    <img
      v-else-if="source"
      :src="source"
      :alt="props.alt"
      :class="imageClasses"
      :title="props.title && props.title.length > 0 ? props.title : props.alt"
      class="size-full"
      data-test-id="img"
      @error="fallBack = true"
    >
    <div
      v-else
      class="bg-blue-200 size-full flex place-items-center"
      :class="imageClasses"
    >
      <img
        :src="MogelijkLogo"
        :alt="props.alt"
        :title="props.title && props.title.length > 0 ? props.title : props.alt"
        class="!w-20 h-min place-self-center mx-auto"
        data-test-id="img"
      >
    </div>
  </div>
</template>
